"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BrandAZSlot;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/elements/button/Button");
const BrandAZSlot_module_scss_1 = __importDefault(require("./BrandAZSlot.module.scss"));
// import { dispatchKevelAnalyticsEvent } from "../../../utils/dispatchAnalytics";
function BrandAZSlot({ associatedAdvertId, slotNumber, ctaLink, ctaText, 
// clickUrl,
// impressionUrl,
mobileImage, tabletImage, desktopImage, accessibilityText, }) {
    return (react_1.default.createElement("a", { id: associatedAdvertId, "data-testid": `brand-az-slot-link-${slotNumber}`, href: ctaLink },
        react_1.default.createElement("div", { "data-testid": `brand-az-slot-image-container-${slotNumber}`, className: BrandAZSlot_module_scss_1.default.imageContainer },
            react_1.default.createElement("picture", null,
                react_1.default.createElement("source", { "data-testid": `brand-az-slot-src-desktop-${slotNumber}`, srcSet: desktopImage, media: "(min-width: 1024px)" }),
                react_1.default.createElement("source", { "data-testid": `brand-az-slot-src-tablet-${slotNumber}`, srcSet: tabletImage, media: "(min-width: 768px)" }),
                react_1.default.createElement("img", { "data-testid": `brand-az-slot-image-${slotNumber}`, src: mobileImage, alt: accessibilityText }))),
        react_1.default.createElement(Button_1.UnderlinedButton, { tag: "button", size: "small", "data-testid": `brand-az-slot-cta-${slotNumber}` }, ctaText)));
}
